export enum RptMenuIds {
  MARKETPLACE_SERVICES = 'rpt-marketplace-services',
  GROWTH_MARKETING = 'rpt-growth-marketing',
  SHARED = 'rpt-shared',
  SETTINGS = 'rpt-settings',
}
